<template>
  <!-- <div class="register-card-main"> -->
  <div :class="['register-card-main', registerClass]">
    <div v-if="userPlatform === 2" class="register-close" @click="closeCard"></div>
    <TipMessage ref="phonefromtip" />

    <div class="re-head-line">
      <div class="re-title">会员注册</div>
      <div class="re-subtitle">立即注册即可领取免费权限</div>
    </div>
    <div class="re-form-container">
      <div class="re-form-item" style="marign-top: 20px">
        <div class="bi-form-label">请选择您的用户类型</div>
        <div class="bi-radio-group">
          <div :class="[radioClass(2)]" @click="radioClick(2)">
            <div class="bi-radio-box"></div>
            <div class="px-2">企业</div>
          </div>

          <div :class="[radioClass(1), 'ml-4']" @click="radioClick(1)">
            <div class="bi-radio-box"></div>
            <div class="px-2">个人</div>
          </div>
        </div>
      </div>
      <div class="re-form-item">
        <img class="re-hasAffix-icon" src="../../assets/images/register/phone.png" alt="" />
        <input type="text" v-model="regiForm.mobile" class="re-input re-hasAffix-input re-hasAffix-input"
          placeholder="请输入您的手机号" maxlength="11" @input="phoneInput" />

        <div class="re-form-item-tip">{{ formErrorTip["mobile"] }}</div>
      </div>
      <div class="re-form-item">
        <img class="re-hasAffix-icon" src="../../assets/images/register/anquan.png" alt="" />

        <input type="text" v-model="regiForm.code" class="re-input re-code-input re-hasAffix-input" placeholder="请输入短信验证码"
          maxlength="6" @input="codeInput" />
        <div class="re-form-item-b-tip">{{ formErrorTip["code"] }}</div>

        <button class="re-code-btn disabled-btn" :disabled="!isCanGetcode" @click="getCode">
          <LoadingCom :loadingValue="checkUserCountLoading" />
          {{ codeText }}
        </button>
      </div>

      <div class="re-form-item" style="margin-bottom: 0; margin-top: 30px">
        <div class="re-form-agree">
          <div class="re-form-checkbox-box" @click="changeCheckbox">
            <img v-if="regiForm.readArgee" src="../../assets/images/register/checkbox-yes.png" alt="" />
          </div>
          <div class="re-form-agree-desc">
            <span :style="readAggreStyle"> 我已阅读并同意 </span>
            <span class="bi-alink" @click="toPage('argee')">《会员服务协议》
            </span>
            和
            <span class="bi-alink" @click="toPage('privateRules')">《隐私政策》
            </span>

            <!-- <a href="/argee">《会员服务协议》</a> -->
          </div>
        </div>
        <!-- <div class="re-form-item-tip">{{ formErrorTip["readArgee"] }}</div> -->
      </div>

      <div class="re-form-item" style="margin-bottom: 10px">
        <input class="re-submit disabled-btn" type="button" :disabled="regiFormLoading" value="完成注册"
          @click="formSubmit" />
        <LoadingCom :loadingValue="regiFormLoading" />
      </div>
      <div class="ref-form-login-tip">
        已有账号前去
        <a href="http://www.baiinfo.com/" target="_blank"> 登录 </a>
      </div>
    </div>

    <div class="re-card-bottom-tip">
      <img class="bottom-tip-icon" src="../../assets/images/register/telephone.png" alt="" />

      客服热线：<a href="tel:18618300427" class="color-t333">18618300427</a>
    </div>

    <VerifySlide ref="verifySlide" />
  </div>
</template>

<script>
import { validatePhone } from "@/utils/formValidate.js";

import { mapMutations, mapState } from "vuex";
import LoadingCom from "@/components/LoadingCom.vue";
import VerifySlide from "../verify/VerifySlide.vue";
import {
  getPhoneCode,
  userRegister,
  checkPhoneCode,
  checkPhoneCount,
} from "@/api/register.js";

const validateCode = (rule, value, callback) => {
  value = parseInt(value);
  const re = /^[0-9]+$/;
  return re.test(value);
};

export default {
  components: {
    LoadingCom,
    VerifySlide,
  },
  data() {
    return {
      regiFormLoading: false,
      checkUserCountLoading: false,
      regiForm: {
        types: 2,
        // 网站链接
        url: "",
        mobile: "",
        readArgee: false,
        code: "",
      },
      // [{phone: Number, isRegister: 1}]
      checkUserCountList: [],
      defaultErrorTip: {
        mobile: "请输入正确的手机号码",
        readArgee: "请确认已阅读《会员服务协议》",
        code: "请输入有效验证码",
      },
      formErrorTip: {
        mobile: "",
        readArgee: "",
        code: "",
      },
      registerLoading: false,
      defaultCodeText: "发送验证码",
      codeText: "发送验证码",
      seconds: 60,
      isCanGetcode: true,
    };
  },
  computed: {
    ...mapState({
      userPlatform: (state) => state.user.userPlatform,
    }),
    readAggreStyle() {
      if (this.formErrorTip["readArgee"]) {
        return {
          color: "#f00",
        };
      }
      return {};
    },
    radioClass() {
      return (radioV) => {
        if (parseInt(radioV) === parseInt(this.regiForm.types)) {
          return "bi-radio-active-container";
        }
        return "bi-radio-container";
      };
    },
    registerClass() {
      if (this.userPlatform === 2) {
        return "register-card-windows-main";
      }
      return "";
    },
  },
  mounted() {
    this.initStoreFormInfo();
  },
  beforeDestroy() {
    this.storeFormInfo();
  },
  methods: {
    ...mapMutations("user", ["setUserMobile"]),
    async verifyImg(callback) {
      this.$refs.verifySlide.verifyImg(callback);
    },
    closeCard() {
      this.$emit("hideCard");
    },
    initStoreFormInfo() {
      let formStr = sessionStorage.getItem("registerForm");
      if (!formStr) {
        return;
      }
      let formContent = JSON.parse(formStr);
      for (const key in formContent) {
        if (
          Object.hasOwnProperty.call(formContent, key) &&
          Object.hasOwnProperty.call(this.regiForm, key)
        ) {
          const element = formContent[key];
          this.regiForm[key] = element;
        }
      }

      // if(formContent['types']){
      //   this.regiForm['types'] = parseInt(formContent['types'])
      // }
      // debugger
      // if(formContent['readArgee'] === 'true'){
      //   this.regiForm['readArgee'] = true
      // } else {
      //   this.regiForm['readArgee'] = false

      // }
    },
    storeFormInfo() {
      let formStr = JSON.stringify(this.regiForm);
      sessionStorage.setItem("registerForm", formStr);
    },
    radioClick(radiov) {
      if (radiov !== this.regiForm.types) {
        this.regiForm.types = radiov;
      }
    },
    toPage(routePath) {
      // this.storeFormInfo()
      this.$router.push({
        path: routePath,
      });
    },
    timeCountDown() {
      this.isCanGetcode = false;
      let startTime = new Date().valueOf();
      let timeDown = this.seconds;
      let timeDownText = "s后重新发送";
      let setTodo = setInterval(() => {
        let nowTime = new Date().valueOf();
        if (nowTime <= startTime + this.seconds * 1000) {
          timeDown--;
          this.codeText = timeDown + timeDownText;
        } else {
          clearInterval(setTodo);
          this.codeText = this.defaultCodeText;
          this.isCanGetcode = true;
        }
      }, 1000);
    },
    verifyImgAndSendCode() {
      this.verifyImg(({ captchaRes, moveLeftDistance }) => {
        return new Promise(async (resolve, reject) => {
          const {
            data,
            backgroundImage,
            templateImage,
            x,
            y,
            backgroundImageTag,
            templateImageTag,
            ...restData
          } = captchaRes;
          // 用户取消 图片滑动校验
          if (!moveLeftDistance && moveLeftDistance !== 0) {
            return;
          }
          let response = null;
          try {
            response = await getPhoneCode({
              // mobileNo: this.regiForm.mobile,
              ...restData,
              phone: this.regiForm.mobile,
              targetX: moveLeftDistance,
              targetY: y,
            });
            const code = response.code;
            const msg = response.msg;
            const msgData = response.data;
            if (code == 400) {
              this.$refs["phonefromtip"].showMessage({
                msg: msg,
                msgType: "error",
              });
              resolve(false);
            } else {
              this.$refs["phonefromtip"].showMessage({
                msg: msgData,
                msgType: "success",
              });
              this.timeCountDown();
              resolve(true);
              // console.log("getcode success response :>> ", response);
            }
          } catch (error) {
            reject(error);
          }
        });
      });
    },
    async getCode() {
      let validateCount = await this.phoneInputBlur();
      let validatePhoneRes = validatePhone(undefined, this.regiForm.mobile);

      if (validatePhoneRes && validateCount !== 1) {
        this.verifyImgAndSendCode();
        // getPhoneCode({
        //   // mobileNo: this.regiForm.mobile,
        //   phone: this.regiForm.mobile,
        // }).then((response) => {
        //   const code = response.code
        //   const msg = response.msg
        //   const data = response.data
        //   if (code == 400) {
        //     this.$refs["phonefromtip"].showMessage({
        //       msg: msg,
        //       msgType: "error",
        //     });
        //   } else {
        //     this.$refs["phonefromtip"].showMessage({
        //       msg: data,
        //       msgType: "success",
        //     });
        //     // console.log("getcode success response :>> ", response);
        //   }
        // });
      } else {
        console.log("validate phone");
      }
    },
    changeCheckbox() {
      this.regiForm.readArgee = !this.regiForm.readArgee;

      if (this.regiForm.readArgee) {
        this.formErrorTip["readArgee"] = "";
        return true;
      } else {
        this.formErrorTip["readArgee"] = this.defaultErrorTip["readArgee"];
        return false;
      }
    },
    phoneInput() {
      if (validatePhone(undefined, this.regiForm.mobile)) {
        this.formErrorTip["mobile"] = "";
        return true;
      } else {
        this.formErrorTip["mobile"] = this.defaultErrorTip["mobile"];
        return false;
      }
    },
    async phoneInputBlur() {
      let validateMobileRes = this.phoneInput();
      if (!validateMobileRes) {
        return 1;
      }
      this.checkUserCountLoading = true;
      let res = await this.checkUserCount();
      this.checkUserCountLoading = false;
      if (res === 1) {
        // 已经注册
        this.formErrorTip["mobile"] = "该手机号已经注册";
      } else {
        this.formErrorTip["mobile"] = "";
      }

      return res;
    },
    codeInput() {
      if (validateCode(undefined, parseInt(this.regiForm.code))) {
        this.formErrorTip["code"] = "";
        return true;
      } else {
        this.formErrorTip["code"] = this.defaultErrorTip["code"];
        return false;
      }
    },

    checkUserCount() {
      let that = this;

      /*
          -1 校验失败
          0  从未注册
          1		已经注册
        */
      return new Promise((resolve) => {
        checkPhoneCount({
          // MobileNo: that.regiForm.mobile,
          phone: that.regiForm.mobile,
        })
          .then((response) => {
            const code = response.code;
            if (code == 400) {
              // 已经注册过
              return resolve(1);
            } else {
              return resolve(0);
            }
          })
          .finally(() => {
            return resolve(1);
          });
      });
    },
    validateReadArgee() {
      if (!this.regiForm.readArgee) {
        this.formErrorTip["readArgee"] = "请阅读服务协议";
        return false;
      }
      return true;
    },
    async validateForm() {
      // let validtePhoneRes = await this.phoneInputBlur();
      let validateCodeRes = this.codeInput();
      let isReadArgee = this.validateReadArgee();

      let formHasError = false;
      // 校验表单错误提示中 是否依然存在 错误提示
      for (const key in this.formErrorTip) {
        if (Object.hasOwnProperty.call(this.formErrorTip, key)) {
          const element = this.formErrorTip[key];
          if (!formHasError) {
            if (element) {
              formHasError = true;
            }
          }
        }
      }

      if (
        // validtePhoneRes !== 1 &&
        validateCodeRes &&
        isReadArgee &&
        !formHasError
      ) {
        return true;
      }
      return false;
    },
    async formSubmit() {
      let that = this;
      let validateRes = await this.validateForm();
      const formContent = {
        url: window.location.href,
        userType: this.regiForm.types,
        phone: this.regiForm.mobile,
        code: this.regiForm.code,
      };
      if (validateRes) {
        this.regiFormLoading = true;
        checkPhoneCode(formContent)
          .then((response) => {
            const code = response.code;
            const msg = response.msg;
            const data = response.data;
            if (code == 400) {
              this.$refs["phonefromtip"].showMessage({
                msg: msg,
                msgType: "error",
              });
            } else {
              that.setUserMobile(that.regiForm.mobile);
              that.$emit("registerFormAfter", that.regiForm.types);
              that.$emit("setUserInfo", data);
            }
            // that.setUserMobile(that.regiForm.mobile);
            // that.$emit("registerFormAfter", that.regiForm.types);
          })
          .catch(() => {
            this.$refs["phonefromtip"].showMessage({
              msg: "网络异常",
              msgType: "error",
            });
            this.regiFormLoading = false;
          })
          .finally(() => {
            this.regiFormLoading = false;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.register-card-main {
  position: relative;
  flex-basis: 1;
  flex-grow: 1;
  padding: 30px 40px;
  background: #ffffff;

  .register-close {
    position: absolute;
    right: 1em;
    top: 1em;
    width: 2em;
    height: 2em;
    padding: 1em;
    background: url("../../assets/images/register/close.png");
    background-position: 50% 50%;
    background-size: 50%;
    background-repeat: no-repeat;
    cursor: pointer;
  }

  .re-head-line {
    height: 0;
    margin-bottom: 10px;
    overflow: hidden;

    .re-title {
      display: inline-block;
      font-size: 22px;

      font-weight: 500;
      color: #333333;
    }

    .re-subtitle {
      padding-left: 1em;
      display: inline-block;

      font-weight: 400;
      color: #333333;
    }
  }

  .re-form-container {
    margin-top: 45px;

    .ref-form-login-tip {
      text-align: right;
      font-size: 12px;

      font-weight: 400;
      color: #333333;
      margin-bottom: 20px;
    }

    .re-form-agree {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 10px 0;
      font-size: 12px;

      .re-form-checkbox-box {
        width: 1rem;
        height: 1rem;
        border: 1px solid #2b304d;
        border-radius: 1px;
        user-select: none;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .re-form-agree-desc {
        margin-left: 0.5rem;
      }
    }

    .re-form-item-tip {
      // position: absolute;
      // bottom: -20px;
      // left: 3rem;
      // font-size: 12px;
      // color: #ff0000;

      position: absolute;
      // bottom: -20px;
      // left: 3rem;
      right: 2em;
      bottom: 10px;
      height: 24px;
      line-height: 24px;
      font-size: 12px;
      color: #ff0000;
    }

    .re-form-item-b-tip {
      position: absolute;
      left: 3rem;
      bottom: -24px;
      height: 24px;
      line-height: 24px;
      font-size: 12px;
      color: #ff0000;
    }

    .re-m-y-0 {
      margin-top: 0;
      margin-bottom: 0;
    }

    .re-form-item {
      position: relative;
      margin-bottom: 10px;
      display: flex;
      justify-content: flex-start;
      color: #333333;

      input {
        color: #333333;
      }

      .bi-form-label {
        flex-basis: 1;

        min-width: 9rem;
        width: 9rem;
        color: #333333;
      }

      .bi-radio-group {
        min-width: 8rem;
        width: 8rem;
        flex-grow: 1;
        display: flex;
        justify-content: flex-start;

        .bi-radio-container,
        .bi-radio-active-container {
          display: flex;
          align-items: center;
          color: #999999;
          cursor: pointer;
          margin-left: 1rem;

          .bi-radio-box {
            width: 14px;
            height: 14px;
            line-height: 14px;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid #999999;
            border-radius: 50%;
            margin-right: 0.5rem;
          }
        }

        .bi-radio-active-container {
          color: #2b304d;

          .bi-radio-box {
            border-color: #2b304d;
            background: #2b304d;
            text-align: center;

            &:after {
              content: "";
              display: block;
              width: 6px;
              height: 6px;
              background: #ffffff;
              border-radius: 50%;
            }
          }
        }
      }

      .disabled-btn:disabled {
        background: #c0c4cc;
        color: #666666;
      }

      .re-code-btn {
        position: absolute;
        right: 10px;
        top: 10px;
        min-width: 5rem;
        // width: 8rem;
        height: 24px;
        font-size: 12px;
        line-height: 24px;
        text-align: center;
        background: #ffffff;
        color: #2b304d;
        border: 1px solid #2b304d;
        margin: 0;
        padding: 0 7px;
        cursor: pointer;

        &:disabled {
          background-color: #efefef;
          color: #949494;
          border: 1px solid #949494;
        }
      }

      .re-input {
        width: 100%;
        // width: 356px;
        height: 44px;
        border: 1px solid #e4e5eb;
        padding: 10px;

        &::placeholder {
          color: #c0c4cc;
        }
      }

      .re-hasAffix-icon {
        position: absolute;
        left: 10px;
        top: 50%;
        transform: translateY(-50%);
        width: 14px;
        height: 16px;
        object-fit: contain;
      }

      .re-hasAffix-input {
        padding-left: calc(0.8rem + 20px);
      }

      .re-code-input {
        padding-right: calc(6rem + 20px);
      }

      .re-submit {
        width: 100%;
        height: 44px;
        line-height: 44px;
        text-align: center;
        background: #2b304d;
        color: #ffffff;
        border: none;
        cursor: pointer;
      }
    }

    .form-select-line {
      display: flex;

      .main-select {
        flex-basis: 1;
        flex-grow: 2;
      }

      .sub-select {
        flex-basis: 1;
        flex-grow: 1;
        margin-left: 10px;
      }

      .form-select {
        border: 1px solid #e4e5eb;
        height: 44px;
        line-height: 40px;
        padding: 0 0.5rem;
        color: #666666;
      }

      .form-select:focus {
        outline: none;
      }

      .form-select::-ms-expand {
        background-color: #ffffff;
        border: none;
      }
    }
  }

  .re-card-bottom-tip {
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    background-color: #f5f6f9;
    height: 40px;

    text-align: center;

    font-size: 12px;

    font-weight: 400;
    color: #333333;

    .bottom-tip-icon {
      width: 1.2em;
      height: 1.2em;
      object-fit: cover;
      margin-right: 1em;
    }
  }
}

.register-card-windows-main {
  // box-sizing: border-box;
  padding-left: 62px !important;
  padding-right: 62px !important;

  .re-head-line {
    display: flex;
    align-items: center;
    height: auto;
  }

  .re-form-container {
    .ref-form-login-tip {
      margin-bottom: 40px;
    }
  }
}
</style>
